import { createContext, useState } from "react";

export const TableDataContext = createContext()

export function TableDataProvider({ children, ..._ }) {
  const [pageRowAndIndex, setPageRowAndIndex] = useState({ row: {}, index: 0 })

  function setRowAndIndex(row, index) {
    setPageRowAndIndex({ row, index })
  }

  return (
    <TableDataContext.Provider
      value={{ pageRowAndIndex, setRowAndIndex }}
    >
      {children}
    </TableDataContext.Provider>
  )
}

